import { render, staticRenderFns } from "./lookinfo.vue?vue&type=template&id=554e825e&scoped=true&"
import script from "./lookinfo.vue?vue&type=script&lang=js&"
export * from "./lookinfo.vue?vue&type=script&lang=js&"
import style0 from "./lookinfo.vue?vue&type=style&index=0&id=554e825e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "554e825e",
  null
  
)

export default component.exports